import { ThemeProps as Prop, ColorProfiles, Components } from '@powdr/constants';

export const defaultTheme = {
  [ColorProfiles.BASE]: {
    [Prop.BACKGROUND]: '#FFFFFF',
    [Prop.HEADER]: '#3F3F3F',
    [Prop.CONTENT]: '#3F3F3F',
    [Prop.LINK_TXT]: '#009bd1',
    [Prop.LINK_TXT_HOVER]: '#009bd1',
    [Prop.BTN_BG]: '#009bd1',
    [Prop.BTN_TXT]: '#FFFFFF',
    [Prop.BTN_BG_HOVER]: '#3F3F3F',
    [Prop.BTN_TXT_HOVER]: '#ffffff',
    [Prop.BTN_BG_ACTIVE]: '#009bd1',
    [Prop.BTN_TXT_ACTIVE]: '#ffffff',
    [Prop.BTN_BG_INACTIVE]: '#b3b3b3',
    [Prop.BTN_TXT_INACTIVE]: '#ffffff',
    [Prop.ELEMENT]: '#3F3F3F',
    [Prop.ELEMENT_TXT]: '#FFFFFF',
    [Prop.BORDER]: '#d9d9d9',
    [Prop.ICON]: '#009bd1',
    [Prop.ICON_HOVER]: '#3f3f3f',
  },
  [ColorProfiles.PRIMARY]: {
    [Prop.BACKGROUND]: '#009bd1',
    [Prop.HEADER]: '#FFFFFF',
    [Prop.CONTENT]: '#FFFFFF',
    [Prop.LINK_TXT]: '#3f3f3f',
    [Prop.LINK_TXT_HOVER]: '#3f3f3f',
    [Prop.BTN_BG]: '#FFFFFF',
    [Prop.BTN_TXT]: '#009bd1',
    [Prop.BTN_BG_HOVER]: '#3F3F3F',
    [Prop.BTN_TXT_HOVER]: '#FFFFFF',
    [Prop.BTN_BG_ACTIVE]: '#FFFFFF',
    [Prop.BTN_TXT_ACTIVE]: '#009bd1',
    [Prop.BTN_BG_INACTIVE]: '#3F3F3F',
    [Prop.BTN_TXT_INACTIVE]: '#FFFFFF',
    [Prop.ELEMENT]: '#FFFFFF',
    [Prop.ELEMENT_TXT]: '#3F3F3F',
    [Prop.BORDER]: '#3F3F3F',
    [Prop.ICON]: '#FFFFFF',
    [Prop.ICON_HOVER]: '#3F3F3F',
  },
  [ColorProfiles.SECONDARY]: {
    [Prop.BACKGROUND]: '#F2F2F2',
    [Prop.HEADER]: '#3F3F3F',
    [Prop.CONTENT]: '#3F3F3F',
    [Prop.LINK_TXT]: '#009bd1',
    [Prop.LINK_TXT_HOVER]: '#009bd1',
    [Prop.BTN_BG]: '#009bd1',
    [Prop.BTN_TXT]: '#FFFFFF',
    [Prop.BTN_BG_HOVER]: '#3F3F3F',
    [Prop.BTN_TXT_HOVER]: '#ffffff',
    [Prop.BTN_BG_ACTIVE]: '#009bd1',
    [Prop.BTN_TXT_ACTIVE]: '#ffffff',
    [Prop.BTN_BG_INACTIVE]: '#3F3F3F',
    [Prop.BTN_TXT_INACTIVE]: '#ffffff',
    [Prop.ELEMENT]: '#009bd1',
    [Prop.ELEMENT_TXT]: '#FFFFFF',
    [Prop.BORDER]: '#3F3F3F',
    [Prop.ICON]: '#009bd1',
    [Prop.ICON_HOVER]: '#3f3f3f',
  },
  [ColorProfiles.TERTIARY]: {
    [Prop.BACKGROUND]: '#B3B3B3',
    [Prop.HEADER]: '#3F3F3F',
    [Prop.CONTENT]: '#3F3F3F',
    [Prop.LINK_TXT]: '#009bd1',
    [Prop.LINK_TXT_HOVER]: '#009bd1',
    [Prop.BTN_BG]: '#FFFFFF',
    [Prop.BTN_TXT]: '#009bd1',
    [Prop.BTN_BG_HOVER]: '#3F3F3F',
    [Prop.BTN_TXT_HOVER]: '#FFFFFF',
    [Prop.BTN_BG_ACTIVE]: '#009bd1',
    [Prop.BTN_TXT_ACTIVE]: '#FFFFFF',
    [Prop.BTN_BG_INACTIVE]: '#3f3f3f',
    [Prop.BTN_TXT_INACTIVE]: '#FFFFFF',
    [Prop.ELEMENT]: '#009bd1',
    [Prop.ELEMENT_TXT]: '#FFFFFF',
    [Prop.BORDER]: '#3f3f3f',
    [Prop.ICON]: '#FFFFFF',
    [Prop.ICON_HOVER]: '#e8f5fa',
  },
  [ColorProfiles.QUATERNARY]: {
    [Prop.BACKGROUND]: '#FFFFFF',
    [Prop.HEADER]: '#3F3F3F',
    [Prop.CONTENT]: '#3F3F3F',
    [Prop.LINK_TXT]: '#009bd1',
    [Prop.LINK_TXT_HOVER]: '#009bd1',
    [Prop.BTN_BG]: '#009bd1',
    [Prop.BTN_TXT]: '#FFFFFF',
    [Prop.BTN_BG_HOVER]: '#3F3F3F',
    [Prop.BTN_TXT_HOVER]: '#ffffff',
    [Prop.BTN_BG_ACTIVE]: '#009bd1',
    [Prop.BTN_TXT_ACTIVE]: '#ffffff',
    [Prop.BTN_BG_INACTIVE]: '#3F3F3F',
    [Prop.BTN_TXT_INACTIVE]: '#ffffff',
    [Prop.ELEMENT]: '#009bd1',
    [Prop.ELEMENT_TXT]: '#FFFFFF',
    [Prop.BORDER]: '#3F3F3F',
    [Prop.ICON]: '#009bd1',
    [Prop.ICON_HOVER]: '#3f3f3f',
  },
  [Components.DOR_LIFTS_TRAILS]: {
    [Prop.ICON_2]: '#009bd1',
    [Prop.ICON_HOVER_2]: '#009bd1',
    [Prop.HEADER_BG]: '#009bd1',
    [Prop.HEADER_TXT]: '#ffffff',
    [Prop.HEADER_ICON]: '#ffffff',
    [Prop.HEADER_BG_2]: '#009bd1',
    [Prop.HEADER_TXT_2]: '#ffffff',
    [Prop.HEADER_ICON_2]: '#ffffff',
    [Prop.TABLE_HEADER_BG]: '#b3b3b3',
    [Prop.TABLE_HEADER_TXT]: '#3F3F3F',
    [Prop.ODD_EVEN_OFFSET]: '#e5eded',
  },

  [Components.HEADER]: {
    [Prop.LOGO_BG]: '#FFFFFF',
    [Prop.NAV_BG]: '#FFFFFF',
    [Prop.NAV_ITEM_TXT_TRANSLUCENT]: '#3F3F3F',
    [Prop.NAV_ITEM_TXT_SOLID]: '#3F3F3F',
    [Prop.NAV_ITEM_TXT_ACTIVE]: '#FFFFFF',
    [Prop.NAV_ITEM_BG_ACTIVE]: '#009bd1',
    [Prop.NAV_ITEM_ACTIVE_ACCENT]: '#009bd1',
    [Prop.WW_ICON_COLOR]: '#FFD200',
    [Prop.LOGO_FOCUS_COLOR]: '#009bd1',
  },

  [Components.MOBILE_NAV]: {
    [Prop.MENU_BTN_BG]: '#FFFFFF',
    [Prop.MENU_BTN_ICON]: '#009bd1',
    [Prop.LOGO_BG]: '#FFFFFF',
    [Prop.CLOSE_BTN_BG]: '#009bd1',
    [Prop.CLOSE_BTN_ICON]: '#FFFFFF',
    [Prop.MAIN_NAV_BG]: '#FFFFFF',
    [Prop.MAIN_NAV_TXT]: '#3F3F3F',
    [Prop.MAIN_NAV_BORDER]: '#3F3F3F',
    [Prop.WW_ICON_COLOR]: '#FFD200',
    [Prop.DRAWER_BTN_BG]: '#FFFFFF',
    [Prop.DRAWER_BTN_TXT]: '#3F3F3F',
    [Prop.PROMO_BTN_BG]: '#FFFFFF',
    [Prop.PROMO_BTN_TXT]: '#3F3F3F',
    [Prop.SUB_NAV_BG]: '#009bd1',
    [Prop.SUB_NAV_TXT]: '#FFFFFF',
    [Prop.SUB_NAV_BORDER]: '#3F3F3F',
    [Prop.NAV_PROMO_ITEM_TEXT]: '#FFFFFF',
  },

  [Components.STICKY_NAV]: {
    [Prop.BTN_TXT]: '#FFFFFF',
    [Prop.BTN_TXT_HOVER]: '#3F3F3F',
    [Prop.BTN_BG_ACTIVE]: '#FFFFFF',
    [Prop.BTN_TXT_ACTIVE]: '#3F3F3F',
  },

  [Components.WEATHER_FEED]: {
    [Prop.BACKGROUND]: '#009bd1',
    [Prop.ICON]: '#FFFFFF',
    [Prop.CONTENT]: '#FFFFFF',
  },

  [Components.PROMOTIONS_FEED]: {
    [Prop.BACKGROUND]: '#009bd1',
    [Prop.LINK_TXT]: '#FFFFFF',
  },

  [Components.ALERT_BAR]: {
    [Prop.BACKGROUND]: '#009bd1',
    [Prop.HEADER]: '#FFFFFF',
    [Prop.CONTENT]: '#FFFFFF',
    [Prop.LINK_TXT]: '#3f3f3f',
    [Prop.LINK_TXT_HOVER]: '#3f3f3f',
    [Prop.BTN_BG]: '#FFFFFF',
    [Prop.BTN_TXT]: '#009bd1',
    [Prop.BTN_BG_HOVER]: '#3F3F3F',
    [Prop.BTN_TXT_HOVER]: '#FFFFFF',
    [Prop.ICON]: '#FFFFFF',
    [Prop.ICON_HOVER]: '#3F3F3F',
  },

  [Components.ECOMMERCE_BANNER]: {
    [Prop.BACKGROUND]: '#FFFFFF',
    [Prop.LINK_TXT]: '#009bd1',
    [Prop.LINK_TXT_HOVER]: '#3f3f3f',
    [Prop.TOGGLE_ACTIVE]: '#009bd1',
    [Prop.TOGGLE_INACTIVE]: '#3f3f3f',
    [Prop.ELEMENT]: '#009bd1',
    [Prop.LINK_SEPARATOR]: '#3f3f3f',
  },

  [Components.MEGA_NAV]: {
    [Prop.LINK_TXT]: '#3f3f3f',
    [Prop.LINK_TXT_HOVER]: '#009bd1',
    [Prop.BORDER]: '#3f3f3f',
  },

  [Components.FOOTER]: {
    [Prop.BACKGROUND]: '#B3B3B3',
    [Prop.HEADER]: '#3F3F3F',
    [Prop.BTN_BG]: '#FFFFFF',
    [Prop.BTN_TXT]: '#009bd1',
    [Prop.BTN_BG_HOVER]: '#3F3F3F',
    [Prop.BTN_TXT_HOVER]: '#FFFFFF',
  },

  [Components.FOOTER_NAV]: {
    [Prop.LINK_TXT]: '#3f3f3f',
    [Prop.LINK_TXT_HOVER]: '#009bd1',
  },

  [Components.COPYRIGHT]: {
    [Prop.BACKGROUND]: '#009bd1',
    [Prop.LINK_TXT]: '#3f3f3f',
  },

  [Components.NAVIGATION_DRAWER]: {
    [Prop.BACKGROUND]: '#FFFFFF',
    [Prop.CLOSE_BTN_BG]: '#FFFFFF',
    [Prop.CLOSE_BTN_ICON]: '#009bd1',
    [Prop.NAV_PROMO_ITEM_TEXT]: '#FFFFFF',
  },

  [Components.NAVIGATION_TOGGLE]: {
    [Prop.NAV_TOGGLE_TXT]: '#FFFFFF',
    [Prop.NAV_TOGGLE_ICON]: '#FFFFFF',
    [Prop.NAV_TOGGLE_TXT_SCROLLED]: '#009bd1',
    [Prop.NAV_TOGGLE_ICON_SCROLLED]: '#009bd1',
  },

  [Components.DOR_DRAWER]: {
    [Prop.BACKGROUND]: '#FFFFFF',
    [Prop.ICON]: '#009bd1',
    [Prop.HEADER]: '#000000',
    [Prop.LINK_TXT]: '#009bd1',
    [Prop.LINK_TXT_HOVER]: '#009bd1',
  },

  [Components.DOR_TOGGLE]: {
    [Prop.BACKGROUND]: '#009bd1',
    [Prop.CONTENT]: '#FFFFFF',
    [Prop.ICON]: '#FFFFFF',
  },

  [Components.SIDEBAR]: {
    [Prop.BACKGROUND]: '#009bd1',
    [Prop.CONTENT]: '#FFFFFF',
  },

  [Components.SIDEBAR_TRAY]: {
    [Prop.BACKGROUND]: '#FFFFFF',
    [Prop.CONTENT]: '#3f3f3f',
  },

  [Components.MAIN_NAV]: {
    [Prop.BACKGROUND]: '#FFFFFF',
    [Prop.BORDER]: '#000000',
    [Prop.CONTENT]: '#000000',
  },

  [Components.GRID]: {
    [Prop.PAGINATION]: '#3f3f3f',
    [Prop.PAGINATION_ACTIVE]: '#3f3f3f',
    [Prop.PAGINATION_HOVER]: '#3f3f3f',
  },

  [Components.UI_TABLE]: {
    [Prop.HEADER_BG]: '#b3b3b3',
  },
};
